export default __webpack_public_path__ + "static/media/movingBulky.b0aa4205.svg";